export default "__VITE_ASSET__B0BHWA4z__"